import { z } from 'zod';
import { emailSchema } from './auth';

export const inviteWriterSchema = z.object({
  email: emailSchema,
});
export type InviteWriterInput = z.infer<typeof inviteWriterSchema>;

/**
 * Editable site copy. The site *name* is deliberately absent: it lives in
 * `apps/web/src/shared/config/site.ts` because titles, canonical URLs and
 * structured data must be identical for crawlers and readers and must be known
 * before any request resolves. There is no admin control for it.
 */
export const siteSettingsSchema = z.object({
  tagline: z.string().trim().max(160).default(''),
  aboutText: z.string().trim().max(600).default(''),
  contactEmail: emailSchema,
  ownerName: z.string().trim().min(1, 'Enter the owner name').max(120),
  ownerRole: z.string().trim().max(160).default(''),
  ownerLocation: z.string().trim().max(160).default(''),
  ownerImage: z
    .string()
    .trim()
    .max(1_500_000, 'Owner picture is too large')
    .refine(
      (value) =>
        value === '' || /^data:image\/(?:jpeg|png|webp);base64,[a-z0-9+/=\s]+$/i.test(value),
      'Upload a JPG, PNG, or WebP image',
    ),
  ownerLinkedInUrl: z
    .string()
    .trim()
    .max(2048)
    .refine(
      (value) => value === '' || /^https?:\/\//i.test(value),
      'Enter a complete http:// or https:// URL',
    ),
  ownerFocus: z.string().trim().max(400).default(''),
  ownerBio: z.string().trim().max(4000).default(''),
});
export type SiteSettingsInput = z.infer<typeof siteSettingsSchema>;
